import { create } from "zustand";
import { IAnalyticsData, ICategory, ICategoryReport, ICategoryReportRequest, ICategoryTimeData, IEmployer, IProject } from "../types";

export interface GlobalAnalyticsData {
	date: [number, number, number, number] // fromYear, fromMonth, toYear, toMonth
	type: "project_statistic_report" | "employee_statistic_report" | "category_statistic_report" | null
	list: IAnalyticsData[]
	categoriesData: ICategoryReport
	categoriesTimeData: ICategoryTimeData
	chosenProjects: IProject[]
	chosenEmployees: IEmployer[]
	chosenProjectsForCategories: IProject[]
	chosenEmployeesForCategories: IEmployer[]
	chosenCategories: ICategory[]
	// Only a category report sets this; the other report types leave it out, so
	// the export can never pick up filters from a previous report.
	categoriesRequest?: ICategoryReportRequest | null
	resultType: "projects" | "employees" | "categories" | null
}

interface GlobalAnalyticsDataState {
	globalAnalyticsData: GlobalAnalyticsData;
	setGlobalAnalyticsData: (data: GlobalAnalyticsData) => void;
}

export const useAnalyticsData = create<GlobalAnalyticsDataState>((set) => ({
	globalAnalyticsData: {
		date: [2024, 1, new Date().getFullYear(), new Date().getMonth()+1],
		type: null,
		list: [],
		categoriesData: { categories: [] },
		categoriesTimeData: {
			categories: [],
			employees: []
		},
		chosenProjects: [],
		chosenEmployees: [],
		chosenProjectsForCategories: [],
		chosenEmployeesForCategories: [],
		chosenCategories: [],
		categoriesRequest: null,
		resultType: null,
	},
	setGlobalAnalyticsData: (globalAnalyticsData) => set({ globalAnalyticsData }),
}));